module.exports = __webpack_public_path__ + "static/media/translations_darkmode.88882fe0.svg";